import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63a5f565"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bus-company-list-container" }
const _hoisted_2 = {
  ref: "scrollContainer",
  class: "content"
}
const _hoisted_3 = {
  key: 0,
  class: "image-wrapper"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "empty-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "전세버스 문의" }),
        _createElementVNode("section", _hoisted_2, [
          ($setup.busCompanyUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("iframe", {
                  class: "layout",
                  src: $setup.busCompanyUrl
                }, null, 8 /* PROPS */, _hoisted_4)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode($setup["EmptyContent"], { text: "전세버스 문의 정보가 없습니다" })
              ]))
        ], 512 /* NEED_PATCH */)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}